// extracted by mini-css-extract-plugin
export default {"categories-suggestions-title":"_14h28fr","categoriesSuggestionsTitle":"_14h28fr","title-text":"_170ce5s","titleText":"_170ce5s"};